import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import moment from 'moment'

export const TRANSACTION_STATUS = [
  { value: 'SUCCESS', label: 'สำเร็จ' },
  { value: 'SUCCESS_HEROCONFIRM', label: 'ฮีโร่ยืนยันแล้ว' },
  { value: 'SUCCESS_PENDING', label: 'รอดำเนินการ' },
  { value: 'DUPLICATE_SUCCESS', label: 'ซ้ำ (สำเร็จ)' },
  { value: 'NO_BIN', label: 'ไม่มีถัง' },
  { value: 'NO_BARCODE', label: 'ไม่มีบาร์โค้ด' },
  { value: 'NO_MANUAL', label: 'ไม่มี manual' },
  { value: 'BARCODE_FAIL', label: 'บาร์โค้ดผิดพลาด' },
  { value: 'USER_KEEP_BIN', label: 'ผู้ใช้เก็บไว้' },
  { value: 'USER_DELETE_BIN', label: 'ผู้ใช้ลบ' },
  { value: 'USER_REJECTED', label: 'ถูกปฏิเสธ' }
]

export const TRANSACTION_WARNING =
  'การสร้าง/แก้ไข/ลบที่นี่เปลี่ยนเฉพาะ transaction ไม่คำนวณแต้ม คาร์บอน หรืออันดับของผู้ใช้ใหม่ และไม่ส่ง webhook'

export const NOTE_MAX_LENGTH = 500

// spec 133: จำนวน = weight ตามหน่วยของวัสดุ (materialUnit)
export const formatAmount = (record) =>
  record.weight === null || record.weight === undefined
    ? '-'
    : `${record.weight} ${record.materialUnit || ''}`.trim()

export const DISCORD_WEBHOOK_REGEX =
  /^https:\/\/(?:(?:ptb|canary)\.)?discord(?:app)?\.com\/api\/webhooks\/\d+\/[\w-]+\/?$/

const ERROR_MESSAGE = {
  UNAUTHORIZED: 'กรุณาเข้าสู่ระบบใหม่',
  BRAND_ACTIVITY_NOT_FOUND: 'ไม่พบกิจกรรม',
  TRANSACTION_NOT_FOUND: 'ไม่พบ transaction',
  WEBHOOK_NOT_FOUND: 'ไม่พบ webhook',
  MATERIAL_ID_IS_REQUIRED: 'กรุณาเลือกวัสดุ',
  MATERIAL_NOT_FOUND: 'ไม่พบวัสดุ',
  WEIGHT_IS_REQUIRED: 'กรุณากรอกน้ำหนัก',
  WEIGHT_MUST_NOT_BE_NEGATIVE: 'น้ำหนักต้องไม่ติดลบ',
  VOLUME_MUST_NOT_BE_NEGATIVE: 'จำนวนต้องไม่ติดลบ',
  STATUS_IS_REQUIRED: 'กรุณาเลือกสถานะ',
  INVALID_TRANSACTION_STATUS: 'สถานะไม่ถูกต้อง',
  START_DATE_AFTER_END_DATE: 'วันเริ่มต้องไม่อยู่หลังวันสิ้นสุด',
  INVALID_DISCORD_WEBHOOK_URL: 'URL Discord webhook ไม่ถูกต้อง',
  WEBHOOK_NAME_TOO_LONG: 'ชื่อต้องไม่เกิน 100 ตัวอักษร',
  NOTE_TOO_LONG: 'หมายเหตุต้องไม่เกิน 500 ตัวอักษร',
  BRAND_HERO_NOT_FOUND: 'Hero นี้ไม่อยู่ในรายชื่อ Hero ของแบรนด์'
}

// แสดงข้อความ error ตาม code จาก backend แล้วคืน HTTP status ให้ผู้เรียกตัดสินใจต่อ
export const showApiError = (err) => {
  const response = err && err.response
  const status = response && response.status
  const code = response && response.data && response.data.message

  if (status === 401) {
    message.error(ERROR_MESSAGE.UNAUTHORIZED)
  } else if (status === 404) {
    message.error(ERROR_MESSAGE[code] || 'ไม่พบข้อมูล')
  } else {
    message.error(ERROR_MESSAGE[code] || 'เกิดข้อผิดพลาด กรุณาลองใหม่')
  }

  return status
}

// แปลงวันที่ UTC จาก backend เป็นเวลาไทย
export const formatBangkokDateTime = (date) =>
  date ? moment(date).utcOffset(420).format('DD/MM/YYYY HH:mm:ss') : '-'

// backend รับ status ซ้ำแบบ ?status=A&status=B (axios ปกติส่งเป็น status[]=)
const serializeParams = (params) => {
  const query = new URLSearchParams()
  Object.keys(params).forEach((key) => {
    const value = params[key]
    if (value === undefined || value === null || value === '') return
    if (Array.isArray(value)) {
      value.forEach((item) => query.append(key, item))
    } else {
      query.append(key, value)
    }
  })
  return query.toString()
}

const basePath = (brandActivityId) =>
  `${EndPoints.BRAND_ACTIVITY}/${brandActivityId}`

export const fetchActivityTransactions = async (brandActivityId, params) => {
  const { data } = await API.get(`${basePath(brandActivityId)}/transactions`, {
    params,
    paramsSerializer: serializeParams
  })
  return data
}

export const fetchAllActivityTransactions = async (params) => {
  const { data } = await API.get(
    `${EndPoints.BRAND_ACTIVITY}/transactions`,
    {
      params,
      paramsSerializer: serializeParams
    }
  )
  return data
}

// ตัวเลือกใน filter ค้นจากชื่อแล้วส่ง id ไป backend
const LOOKUP_OPTIONS = { page: 0, size: 20 }

const toKeyword = (keyword) => (keyword ? `%${keyword}%` : '')

export const searchFilterUsers = async (keyword) => {
  const { data } = await API.get(`${EndPoints.APPUSER}/search`, {
    params: { ...LOOKUP_OPTIONS, keyword: toKeyword(keyword) }
  })
  return (data && data.content) || []
}

export const searchFilterHeroes = async (keyword) => {
  const { data } = await API.get(`${EndPoints.HERO}/search`, {
    params: { ...LOOKUP_OPTIONS, keyword: toKeyword(keyword) }
  })
  return (data && data.content) || []
}

export const fetchFilterBrands = async () => {
  const { data } = await API.get(EndPoints.BRAND)
  return data || []
}

export const fetchFilterBrandActivities = async (brandId) => {
  const { data } = await API.post(`${EndPoints.BRAND_ACTIVITY}/activity-list`, {
    brandId: brandId,
    enable: false
  })
  return (data && data.brandActivityList) || []
}

export const createActivityTransaction = async (brandActivityId, body) => {
  const { data } = await API.post(
    `${basePath(brandActivityId)}/transactions`,
    body
  )
  return data
}

export const updateActivityTransaction = async (
  brandActivityId,
  transactionId,
  body
) => {
  const { data } = await API.put(
    `${basePath(brandActivityId)}/transactions/${transactionId}`,
    body
  )
  return data
}

export const deleteActivityTransaction = async (
  brandActivityId,
  transactionId
) => {
  const { data } = await API.delete(
    `${basePath(brandActivityId)}/transactions/${transactionId}`
  )
  return data
}

export const fetchActivityWebhooks = async (brandActivityId) => {
  const { data } = await API.get(`${basePath(brandActivityId)}/webhooks`)
  return data
}

export const createActivityWebhook = async (brandActivityId, body) => {
  const { data } = await API.post(`${basePath(brandActivityId)}/webhooks`, body)
  return data
}

export const updateActivityWebhook = async (
  brandActivityId,
  webhookId,
  body
) => {
  const { data } = await API.put(
    `${basePath(brandActivityId)}/webhooks/${webhookId}`,
    body
  )
  return data
}

export const updateActivityWebhookEnabled = async (
  brandActivityId,
  webhookId,
  enabled
) => {
  const { data } = await API.put(
    `${basePath(brandActivityId)}/webhooks/${webhookId}/enabled`,
    null,
    { params: { enabled } }
  )
  return data
}

export const deleteActivityWebhook = async (brandActivityId, webhookId) => {
  const { data } = await API.delete(
    `${basePath(brandActivityId)}/webhooks/${webhookId}`
  )
  return data
}
